import React from 'react'

//HeaderTop use to set almabetter logo in top
const HeaderTop = () => {
  return (
    <div className=' bg-white shadow-lg py-2 px-2 mx-4 rounded '>
        <img className='h-6' src="https://www.almabetter.com/_next/image?url=https%3A%2F%2Falmablog-media.s3.ap-south-1.amazonaws.com%2Flogo1_edfc81b31b.png&w=384&q=75" alt="" srcset="" />
    </div>
  )
}

export default HeaderTop